/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import { Location, Clock, Call, Sms } from '../../../icons'
import ContactAPI from '../../../api/contact'
import text from '../../../utils/translate.json'
import Loading from '../../../components/pages/loading'
import { PageContext } from '../../../context/PageContextProvider'

const Contact = () => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [contact, setContact] = useState([])
  useEffect(() => {
    (async () => {

    const { data } = await ContactAPI.getAll()
    await setContact(data)
    await setLoad(true)
  
    })();
  }, [])
  return load ? (
    <div className={styles['contact-container']}>
      <div className={styles.contact}>
        <span>{text.ours[language]}</span>
        <h2>{text.contact[language]}</h2>

        <div className={styles['contact-items']}>
          <div>
            <span>
              <Location />
            </span>
            <p>{text.location[language]}</p>
            <div>
              {contact.location.map((item, idx) => (
                <span key={idx}>{item[language] || item.TR || item.AZ}</span>
              ))}
            </div>
          </div>
          <div>
            <span>
              <Clock />
            </span>
            <p>{text.working[language]}</p>
            <div>
              <span>{contact?.working_hours?.[language] || contact?.working_hours?.TR || contact?.working_hours?.AZ}</span>
            </div>
          </div>
          <div>
            <span>
              <Call />
            </span>
            <p>{text.call[language]}</p>
            <div>
              {contact.phone.map((item) => (
                <a href={`tel:${item}`}>{item}</a>
              ))}
            </div>
          </div>
          <div>
            <span>
              <Sms />
            </span>
            <p>{text.email[language]}</p>
            <div>
              {contact.email.map((item) => (
                <a href={`mailto:${item}`}>{item}</a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Loading />
  )
}

export default Contact
